import React from 'react';
import styles from './SuccessMessage.module.css';

const SuccessMessage: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <svg
          className={styles.checkIcon}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      <h1 className={styles.title}>Anfrage gesendet!</h1>

      <p className={styles.message}>
        Vielen Dank für dein Interesse an der insur_tale Toolbox. Deine Anfrage wurde erfolgreich gesendet und ich kümmere mich so schnell wie möglich um deinen Zugang.
      </p>

      <div className={styles.infoBox}>
        <h3>Was passiert als nächstes?</h3>
        <ul>
          <li>Ich erstelle deinen Zugang zur Toolbox</li>
          <li>Du bekommst eine E-Mail sobald dein Zugang erstellt wurde</li>
          <li>Normalerweise sollte es nicht länger als 24 Stunden dauern</li>
        </ul>
      </div>

      <p className={styles.footer}>
        Hast du Fragen? Melde dich gerne bei mir via LinkedIn.
      </p>
    </div>
  );
};

export default SuccessMessage;
